import { createFileRoute } from '@tanstack/react-router'
import { NewCollaboratorPage } from '~/components/routes/logistics/collaborator-page'
import { LogisticsRecordRoute } from '~/components/routes/logistics/logistics-record-page'
import { LOGISTICS_COLLABORATOR_ADD } from '~/components/routes/logistics/tabs'
import { withRoutePermissions } from '~/utils/rbac'
import { logisticsSearchSchema } from '../-search-schema'

export const Route = createFileRoute('/_authenticated/logistics/collaborators/new')({
  staticData: {
    permission: LOGISTICS_COLLABORATOR_ADD,
  },
  component: NewCollaboratorRoute,
  validateSearch: logisticsSearchSchema,
})
withRoutePermissions(Route)

function NewCollaboratorRoute() {
  return (
    <LogisticsRecordRoute
      tab="hr"
      search={Route.useSearch()}
      permission={LOGISTICS_COLLABORATOR_ADD}
    >
      {(search) => <NewCollaboratorPage search={search} />}
    </LogisticsRecordRoute>
  )
}
